import React, { useState, useEffect } from 'react';
import { ChevronLeft } from '@material-ui/icons';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from 'aws-sdk/clients/quicksight';
import Typography from '../Typography';
import { colors } from '../../config/color';
import { fonts } from '../../config/font';
import planStyle from '../../styles/Plan.module.scss';

interface IBackButton {
  url?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    svgStyle: {
      color: `${colors.primary} !important`,
      ['@media (max-width:576px)']: {
        color: `${colors.white} !important`,
      },
    },
    textStyle: {
      color: `${colors.lightGray} !important`,
      '&:hover': {
        color: `${colors.primary} !important`,
        textDecoration: 'underline',
      },
      ['@media (max-width:576px)']: {
        color: `${colors.white} !important`,
        '&:hover': {
          color: `${colors.white} !important`,
        },
      },
    },
  }),
);

export default function BackButton(props: IBackButton) {
  const { url, onClick, style } = props;
  const classes = useStyles();

  const { t } = useTranslation('common');
  const router = useRouter();
  const [hovered, setHovered] = useState<boolean>(false);

  const handleClick = () => {
    onClick && onClick();
    url && router.replace(url);
  };

  return (
    <div
      className={planStyle.backButton}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={style}>
      <ChevronLeft className={classes.svgStyle} />
      <Typography fontFamily={fonts.LATO} fontSize={16} fontWeight={400} className={classes.textStyle}>
        {t('general.cancel')}
      </Typography>
    </div>
  );
}
